import React from 'react';
import { Helmet } from "react-helmet";
import { FaPenNib, FaSearchDollar, FaLayerGroup, FaChartLine, FaCheckCircle } from 'react-icons/fa';
import "./ContentWriting.css";

const ContentWriting = () => {
  return (
    <main className="service-page">
      <Helmet>
        {/* ✅ TITLE */}
        <title>SEO Content Writing Services | Skyline Bussiness Solutions</title>

        {/* ✅ META */}
        <meta 
          name="description" 
          content="High-authority SEO content writing services by Skyline Bussiness Solutions. We create blogs, landing pages, and content that ranks on Google and converts users." 
        />

        {/* ✅ CANONICAL */}
        <link rel="canonical" href="https://skylinebussinesssolutions.com/content-writing" />

        {/* ✅ OPEN GRAPH */}
        <meta property="og:title" content="SEO Content Writing | Skyline Bussiness Solutions" />
        <meta property="og:description" content="SEO blogs, conversion copy, and technical writing services." />
        <meta property="og:url" content="https://skylinebussinesssolutions.com/content-writing" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* HERO */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">AUTHORITY & RANKING</span>

          <h1 className="service-display">
            Strategic <br />
            <span className="accent-text">Content Writing</span>
          </h1>

          <p className="service-intro">
            At <strong>Skyline Business Solutions</strong>, we don’t just write words — 
            we engineer <strong>SEO-optimized content</strong> that ranks on Google 
            and drives real business growth.
          </p>
        </div>
      </header>

      <div className="service-container">
        
        {/* STRATEGY */}
        <section className="strategy-section">
          <div className="strategy-card">
            <div className="strat-icon"><FaSearchDollar /></div>
            <h3>Intent Research</h3>
            <p>We target high-converting keywords based on real user intent.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaLayerGroup /></div>
            <h3>SEO Structure</h3>
            <p>Optimized headings, LSI keywords, and semantic structure.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaPenNib /></div>
            <h3>Brand Voice</h3>
            <p>Content aligned with your industry tone and audience.</p>
          </div>
        </section>

        {/* SERVICES */}
        <section className="capabilities-grid">

          <div className="glass-card">
            <FaChartLine className="card-icon" />
            <h3>SEO Blogs</h3>
            <p>Long-form articles designed to rank and build authority.</p>
          </div>

          <div className="glass-card">
            <FaCheckCircle className="card-icon" />
            <h3>Conversion Copy</h3>
            <p>Landing page content that increases leads and sales.</p>
          </div>

          <div className="glass-card">
            <FaPenNib className="card-icon" />
            <h3>Technical Writing</h3>
            <p>Clear and SEO-friendly documentation & whitepapers.</p>
          </div>

        </section>

        {/* WORKFLOW */}
        <section className="workflow-section">
          <div className="section-header">
            <h2>Our Editorial Process</h2>
            <div className="line"></div>
          </div>

          <div className="workflow-steps">
            <div className="step">
              <span>01</span>
              <h4>Audit</h4>
              <p>We analyze your existing content gaps.</p>
            </div>

            <div className="step">
              <span>02</span>
              <h4>Create</h4>
              <p>We write high-quality, plagiarism-free content.</p>
            </div>

            <div className="step">
              <span>03</span>
              <h4>Optimize</h4>
              <p>We optimize for SEO, readability, and conversions.</p>
            </div>
          </div>
        </section>

      </div>

      {/* ✅ SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "SEO Content Writing Services",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solutions",
            "url": "https://skylinebussinesssolutions.com"
          },
          "areaServed": "Worldwide",
          "description": "SEO blog writing, landing pages, and content marketing services."
        })}
      </script>
    </main>
  );
};

export default ContentWriting;